export default __webpack_public_path__ + "static/media/set6.4dd02c4a.jpeg";